import React, { FC } from 'react';
import TableSimple from 'src/components/TableSimple';
import { TableColumnType } from 'src/types/table';
import { ProductStockTransfersProductType } from 'src/types/productStockTransfers';

export type EditKeysType = 'PRODUCT_COUNT' | 'PRODUCT_SKU';

const allColumns: TableColumnType[] = [
    {
        key: 'id',
        label: 'id',
        type: 'number',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'snapshotDate',
        label: 'snapshotDate',
        type: 'dateTime',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'stockQuantity',
        label: 'stockQuantity',
        type: 'number-filter',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'description',
        label: 'description',
        defaultShow: true,
        customRender: true,
    },
];

type ProductStockTransfersTablePropsType = {
    data?: ProductStockTransfersProductType[] | null;
};

const ProductStockTransfersTable: FC<ProductStockTransfersTablePropsType> = (props) => {
    return (
        <TableSimple
            rowIdKey="id"
            rows={props.data || []}
            columsLabelPrefix="productStockTransfersDetail.productsTable"
            allColumns={allColumns}
            initSort={{ column: 'id', direction: 'ASC', createIdNumber: true }}
        />
    );
};

export default ProductStockTransfersTable;
